import script from "./Models.vue?vue&type=script&setup=true&lang=js"
export * from "./Models.vue?vue&type=script&setup=true&lang=js"

import "./Models.vue?vue&type=style&index=0&id=7ac9d766&lang=css"

const __exports__ = script;

export default __exports__